import http from "@/services/http"

export function get(body) {
  return http.post("audit/items", body)
}
export function post(body) {
  return http.postStealth("audit/create", body)
}

export function getReport(body, filename) {
  return http.downloadXLS("audit/excel", body, filename)
}


export default {
  get,
  post,
  getReport,
}
